import { useContext } from 'react';

import { ChartLayoutTemplateContext } from '../context/ChartLayoutTemplate.context.js';

/**
 * @internal
 */
export const useChartLayoutTemplate = () =>
  useContext(ChartLayoutTemplateContext);
